export default __webpack_public_path__ + "assets/icon-logo-circle.58edafa3.webp";